import { DateRangeType } from "@fluentui/react-calendar-compat";

export const dateRangeOptions = {
  Day: DateRangeType.Day,
  "Work Week": DateRangeType.WorkWeek,
  Week: DateRangeType.Week,
  Month: DateRangeType.Month,
  Custom: "Custom",
};

export const minDate = new Date(2024, 9, 25);
export const maxDate = new Date();

export const getStartAndEndOfPeriod = (
  selectedDate: Date,
  dateRangeType: string,
): { startDate: Date; endDate: Date } => {
  const startDate = new Date(selectedDate);
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(selectedDate);
  endDate.setHours(23, 59, 59, 999);

  switch (dateRangeType) {
    case "Day":
      break;
    case "Week":
      const dayOfWeek = selectedDate.getDay();
      startDate.setDate(selectedDate.getDate() - dayOfWeek);
      endDate.setDate(startDate.getDate() + 6);
      break;
    case "Work Week":
      const dayOfWorkWeek = selectedDate.getDay();
      startDate.setDate(
        selectedDate.getDate() - (dayOfWorkWeek === 0 ? 6 : dayOfWorkWeek - 1),
      );
      endDate.setDate(startDate.getDate() + 4);
      break;
    case "Month":
      startDate.setDate(1);
      endDate.setMonth(selectedDate.getMonth() + 1, 0);
      break;
  }
  return { startDate, endDate };
};
